(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
if (!customElements.get('suds-cart-packaging')) {
  customElements.define('suds-cart-packaging', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const button = this.querySelector('button');
      if (!button) return;
      button.addEventListener('click', async () => {
        if (button.disabled) return;
        button.disabled = true;
        const error = this.querySelector('[role="alert"]');
        error.hidden = true;
        try {
          const stateResponse = await fetch(this.dataset.cartUrl + '.js', {headers: {'Accept': 'application/json'}, cache: 'no-store'});
          if (!stateResponse.ok) throw new Error('We could not check your cart. Please try again.');
          const state = await stateResponse.json();
          if (!state.items.some(item => Number(item.variant_id) === Number(this.dataset.variant))) {
            const response = await fetch(this.dataset.addUrl, {
              method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
              body: JSON.stringify({items: [{id: Number(this.dataset.variant), quantity: 1, properties: {'Gift selection': 'Gift packaging for this order'}}]})
            });
            const result = await response.json();
            if (!response.ok) throw new Error(result.description || 'Packaging could not be added. Please try again.');
          }
          window.location.assign(this.dataset.cartUrl);
        } catch (failure) {
          error.textContent = failure.message || 'Packaging could not be added. Please try again.';
          error.hidden = false;
          button.disabled = false;
          error.focus();
        }
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["suds-gifts"] && !Shopify.designMode) return;
  try {
    
function openSudsGiftFromHash() {
 const hash=window.location.hash.slice(1);
 if(!hash)return;
 const target=document.getElementById(decodeURIComponent(hash));
 if(target && target.matches('details.suds-gifts__card')) {
   document.querySelectorAll('#SudsGifts details.suds-gifts__card').forEach(card=>{card.open = card===target;});
 }
}
window.addEventListener('hashchange',openSudsGiftFromHash);
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',openSudsGiftFromHash,{once:true});else openSudsGiftFromHash();
if (!customElements.get('suds-gift-builder')) {
 customElements.define('suds-gift-builder', class extends HTMLElement {
 connectedCallback() {
  if(this.initialized)return;
  this.initialized=true;
  const form=this.querySelector('form'),button=form.querySelector('[type="submit"]'),output=form.querySelector('output'),error=form.querySelector('[role="alert"]');
  const formatter=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:this.dataset.currency||'USD'});
  let busy=false;
  const normalButtonText=button.textContent;
  const rows=()=>[...form.querySelectorAll('.suds-gifts__row')];
  const filterRow=row=>{
   const kind=row.querySelector('[data-row-category]').value;
   const note=row.querySelector('[data-scrub-note]');
   if(note)note.hidden=kind!=='scrub';
   const product=row.querySelector('select:not([data-row-category])');
   [...product.options].forEach((option,index)=>{
    const hide=index>0&&option.dataset.category!==kind;
    option.hidden=hide;option.disabled=hide;
   });
   if(product.selectedOptions[0]?.disabled)product.value='';
   product.disabled=!kind;
   update();
  };
  form.addEventListener('change',event=>{
   if(event.target.matches('[data-row-category]'))filterRow(event.target.closest('.suds-gifts__row'));
  });
  const selections=()=>rows().filter(row=>row.querySelector('select:not([data-row-category])').value).map(row=>({id:row.querySelector('select:not([data-row-category])').value,quantity:Number(row.querySelector('input').value),price:Number(row.querySelector('select:not([data-row-category])').selectedOptions[0].dataset.price)}));
  const update=()=>{
   rows().forEach(row=>{
    const select=row.querySelector('select:not([data-row-category])');
    const detailLink=row.querySelector('[data-product-info-link]');
    if(!detailLink)return;
    const productUrl=select.selectedOptions[0]?.dataset.productUrl;
    if(productUrl){
      detailLink.href=productUrl;
      detailLink.hidden=false;
    }else{
      detailLink.removeAttribute('href');
      detailLink.hidden=true;
    }
   });
   const chosen=selections();
   const packaging=form.querySelector('[data-gift-packaging]')?.checked && !Number(this.dataset.packagingInCart);
   output.textContent=formatter.format((chosen.reduce((sum,item)=>sum+item.price*(Number.isFinite(item.quantity)?item.quantity:0),0)+(packaging?Number(this.dataset.packagingPrice):0))/100);
   const summary=form.querySelector('[data-gift-summary]');
   summary.replaceChildren();
   const heading=document.createElement('strong');
   const itemCount=chosen.reduce((sum,item)=>sum+(Number.isInteger(item.quantity)&&item.quantity>0?item.quantity:0),0);
   heading.textContent=itemCount?'Your Suds Bag ('+itemCount+' '+(itemCount===1?'item':'items')+')':'Your Suds Bag';
   summary.append(heading);
   if(!chosen.length){const empty=document.createElement('p');empty.textContent='Choose your first goodie to start building your bag.';summary.append(empty);}
   rows().forEach(row=>{
    const select=row.querySelector('select:not([data-row-category])');
    if(!select.value)return;
    const line=document.createElement('p');
    const qty=Number(row.querySelector('input').value);
    const unitPrice=Number(select.selectedOptions[0].dataset.price);
    line.textContent=select.selectedOptions[0].textContent+' × '+qty+(Number.isFinite(unitPrice)&&Number.isFinite(qty)&&qty>0?' = '+formatter.format(unitPrice*qty/100):'');
    summary.append(line);
   });
   if(Number(this.dataset.packagingInCart)){const existingLine=document.createElement('p');existingLine.textContent='Gift bag packaging is already in your cart; no additional packaging charge.';summary.append(existingLine);}
   if(packaging){const giftLine=document.createElement('p');giftLine.textContent='Gift bag packaging — '+formatter.format(Number(this.dataset.packagingPrice)/100);summary.append(giftLine);}
   button.disabled=busy||chosen.length===0||chosen.some(item=>!Number.isInteger(item.quantity)||item.quantity<1);
  };
  form.addEventListener('change',update);
  form.addEventListener('input',update);
  const moreButton=form.querySelector('[data-add-choice]');
  moreButton.textContent='Add Another Goodie';
  form.querySelector('[data-add-choice]').addEventListener('click',()=>{
   const row=rows()[0].cloneNode(true),index=Date.now().toString(36)+Math.random().toString(36).slice(2,6);
   row.querySelector('[data-row-category]').value='';
   const scrubNote=row.querySelector('[data-scrub-note]');
   if(scrubNote)scrubNote.hidden=true;
   row.querySelector('select:not([data-row-category])').value='';
   row.querySelector('input').value='1';
   row.querySelectorAll('[id]').forEach(el=>{const old=el.id;el.id=old+'-extra-'+index;row.querySelectorAll('label').forEach(label=>{if(label.htmlFor===old)label.htmlFor=el.id;});});
   [...row.querySelector('select:not([data-row-category])').options].forEach((option,index)=>{
    const hidden=index>0;
    option.hidden=hidden;option.disabled=hidden;
   });
   const remove=document.createElement('button');remove.type='button';remove.className='suds-gifts__remove';remove.textContent='Remove this goodie';remove.setAttribute('aria-label','Remove this goodie from the bag');remove.addEventListener('click',()=>{row.remove();update();});row.append(remove);
   form.querySelector('[data-gift-rows]').append(row);
   row.querySelector('[data-row-category]').focus();
   update();
  });
  form.querySelector('[data-clear-bag]').addEventListener('click',()=>{
   rows().slice(1).forEach(row=>row.remove());
   const first=rows()[0];
   first.querySelector('[data-row-category]').value='';
   first.querySelector('select:not([data-row-category])').value='';
   first.querySelector('input').value='1';
   form.querySelector('[data-gift-packaging]').checked=false;
   const notes=form.querySelector('[data-gift-instructions]');
   if(notes)notes.value='';
   error.hidden=true;error.textContent='';
   filterRow(first);
   first.querySelector('[data-row-category]').focus();
  });
  form.addEventListener('submit',async event=>{
   event.preventDefault();
   if(busy||button.disabled||!form.reportValidity())return;
   busy=true;button.textContent='Adding your goodies…';update();form.setAttribute('aria-busy','true');error.hidden=true;
   const group=Date.now()+'-'+Math.random().toString(36).slice(2,9);
   const giftInstructions=(form.querySelector('[data-gift-instructions]')?.value||'').trim();
   const merged=new Map();
   selections().forEach(item=>merged.set(item.id,(merged.get(item.id)||0)+item.quantity));
   const giftProperties={'Gift selection':form.dataset.giftTitle,'_suds_gift_group':group};
   const items=[...merged].map(([id,quantity])=>({id,quantity,properties:{...giftProperties}}));
   try{
    const cartResponse=await fetch(this.dataset.cartStateUrl,{headers:{'Accept':'application/json'},cache:'no-store'});
    if(!cartResponse.ok)throw new Error('We could not check your cart. Please try again.');
    const currentCart=await cartResponse.json();
    const hasPackaging=currentCart.items.some(item=>Number(item.variant_id)===Number(this.dataset.packagingVariant));
    if(form.querySelector('[data-gift-packaging]')?.checked && !hasPackaging){
     const packagingProperties={'Gift selection':'Gift packaging for this order'};
     if(giftInstructions)packagingProperties['Gift instructions']=giftInstructions;
     items.push({id:Number(this.dataset.packagingVariant),quantity:1,properties:packagingProperties});
    }else if(giftInstructions && items.length){
     items[0].properties['Gift instructions']=giftInstructions;
    }
    const response=await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
    const data=await response.json();
    if(!response.ok)throw new Error(typeof data.description==='string'?data.description:this.dataset.error);
    window.location.assign(this.dataset.cartUrl);
   }catch(failure){
    error.textContent=(failure.message||'')+' '+this.dataset.error;error.hidden=false;
    busy=false;button.textContent=normalButtonText;form.removeAttribute('aria-busy');update();
    error.focus();
   }
  });
  rows().forEach(filterRow);
 }
 });
}
  } catch(e) { console.error(e); }
})();
})();
